(
    // TODO: [PR 4380821] Convert entire (mobile) Main Menu to Vue
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.mainMenu = skyward.mainMenu || {};

        var cache = skyward.mainMenuVueBuilder.getCache();

        var classes = skyward.mainMenuVueBuilder.getClasses();

        skyward.mainMenu.toggleMenu = function ()
        {
            if (skyward.mainMenu.isMenuOpen())
            {
                skyward.mainMenu.closeMenu();
            }
            else
            {
                skyward.mainMenu.openMenu();
            }
        };

        var mobileMenu = function ()
        {
            var htmlConstructor = function (layoutParts)
            {
                var constructor =
                {
                    layoutParts: layoutParts
                };

                var expandableMenu = (function ()
                {
                    $(document.body).on("click", classes.menuGroup.dot(), function (event)
                    {
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }

                        event.preventDefault();

                        var li = $(event.target).closest([classes.menuGroupTitle.dot(), classes.menuGroupItem.dot()].join(","));

                        if (!li.length)
                        {
                            return;
                        }

                        var ul = $(this);
                        var shouldToggle = li.hasClass(classes.menuGroupTitle);
                        var afterToggleShow, afterToggleHide;
                        var dataOn = li.data("menu-on");

                        for (var on in dataOn)
                        {
                            switch (on)
                            {
                                case "click":
                                    dataOn[on].apply(li[0], [li]);
                                    break;
                            }
                        }

                        dataOn = ul.data("menu-on");

                        if (typeof dataOn === "object")
                        {
                            afterToggleShow = dataOn["after-toggle-show"];
                            afterToggleHide = dataOn["after-toggle-hide"];

                            if (dataOn["before-toggle-show"] && !ul.hasClass(classes.menuGroupExpanded))
                            {
                                shouldToggle = false;
                                ul.addClass(classes.menuGroupBusy);
                                $.when(dataOn["before-toggle-show"].apply(ul[0], [ul])).done(function ()
                                {
                                    ul.removeClass(classes.menuGroupBusy);
                                    toggleExpand(true);
                                });
                            }
                        }

                        if (shouldToggle)
                        {
                            toggleExpand(!ul.hasClass(classes.menuGroupExpanded));
                        }

                        function toggleExpand(expand)
                        {
                            if (expand)
                            {
                                var searchLi = ul.children(classes.menuGroupSearch.dot());
                                if (searchLi.length && searchLi.siblings(classes.menuGroupItem.dot()).length < searchLi.data("searchItemThreshold"))
                                {
                                    searchLi.hide();
                                }
                                ul.addClass(classes.menuGroupExpanded);
                                if (typeof afterToggleShow === "function")
                                {
                                    afterToggleShow.apply(ul[0], [ul]);
                                }
                            }
                            else
                            {
                                ul.removeClass(classes.menuGroupExpanded);
                                if (typeof afterToggleHide === "function")
                                {
                                    afterToggleHide.apply(ul[0], [ul]);
                                }
                            }
                        }
                    })
                        .on("keyup", classes.menuGroupSearchBox.dot(), function (event)
                        {
                            var input = $(this);
                            var searchLi = input.parent();
                            var messageLi = searchLi.find(classes.menuGroupSearchMessage.dot());
                            var clearDiv = searchLi.find(classes.menuGroupSearchClear.dot());
                            var searchText = input.val().toLowerCase();
                            var hiddenCount = 0, shownCount = 0, searchMessage = "";

                            searchLi.siblings(classes.menuGroupItem.dot()).each(function ()
                            {
                                var item = $(this);
                                var itemText = item.text().toLowerCase();
                                if (!searchText.length || itemText.indexOf(searchText) >= 0)
                                {
                                    item.removeClass(classes.menuGroupSearchItemHidden);
                                    shownCount++;
                                }
                                else
                                {
                                    item.addClass(classes.menuGroupSearchItemHidden);
                                    hiddenCount++;
                                }
                            });

                            if (searchText.length)
                            {
                                clearDiv.show();

                                if (shownCount === 0)
                                {
                                    searchMessage = "No matching results";
                                }
                                else if (hiddenCount > 0)
                                {
                                    searchMessage = "Hiding " + hiddenCount + " result" + (hiddenCount > 1 ? "s" : "");
                                }
                                else if (shownCount > 0)
                                {
                                    searchMessage = shownCount + " matching result" + (shownCount > 1 ? "s" : "");
                                }
                            }
                            else
                            {
                                clearDiv.hide();
                            }

                            if (searchMessage)
                            {
                                messageLi.html(searchMessage);
                                searchLi.addClass(classes.menuGroupSearchHasMessage);
                            }
                            else
                            {
                                searchLi.removeClass(classes.menuGroupSearchHasMessage);
                            }
                        })
                        .on("click", classes.menuGroupSearchClear.dot(), function (event)
                        {
                            $(this).siblings(classes.menuGroupSearchBox.dot()).val("").trigger("keyup");
                        });

                    function concatClasses()
                    {
                        var classes = [];
                        Array.from(arguments).map(function (arg)
                        {
                            if (typeof arg === "string")
                            {
                                classes.push(arg);
                            }
                            else if (typeof arg === "object" && arg !== null && arg.length)
                            {
                                classes = classes.concat(arg);
                            }
                        });
                        return classes.join(" ");
                    }

                    function createElement(tagName, className, options)
                    {
                        options = options || {};

                        if (typeof options.class === "function")
                        {
                            options.class = options.class();
                        }

                        var element = $("<" + tagName + ">",
                            {
                                class: concatClasses(className, options.class)
                            });

                        if (options.data)
                        {
                            element.data(options.data);
                        }

                        if (options.on)
                        {
                            element.data("menu-on", options.on);
                        }

                        if (options.svg)
                        {
                            if (typeof options.svg === "function")
                            {
                                options.svg = options.svg();
                            }
                            element.append($(options.svg).addClass(classes.menuGroupSvg));
                        }

                        if (options.label)
                        {
                            element.append($("<div>", { class: classes.menuGroupLabel, html: options.label }));
                        }

                        return element;
                    }

                    var expandableMenu =
                    {
                        create: function (options)
                        {
                            options = options || {};

                            var element = expandableMenu.createContainer(options.container || {});

                            if (options.title)
                            {
                                element.append(expandableMenu.createTitle(options.title));
                            }

                            if (options.searchable)
                            {
                                element.append(expandableMenu.createSearch(options.search));
                            }

                            if (options.items)
                            {
                                if (typeof options.items === "function")
                                {
                                    options.items = options.items();
                                }
                                options.items.map(function (item)
                                {
                                    if (item.isHeader)
                                    {
                                        element.append(expandableMenu.createHeader(item));
                                    }
                                    else
                                    {
                                        element.append(expandableMenu.createItem(item));
                                    }
                                });
                            }

                            return element;
                        },
                        createContainer: function (options)
                        {
                            return createElement("ul", classes.menuGroup, options);
                        },
                        createTitle: function (options)
                        {
                            return createElement("li", classes.menuGroupTitle, options).append($("<div>", { class: classes.menuGroupChevron }));
                        },
                        createItem: function (options)
                        {
                            return createElement("li", classes.menuGroupItem, options);
                        },
                        createHeader: function (options)
                        {
                            return createElement("li", classes.menuGroupHeader, options);
                        },
                        createSearch: function (options)
                        {
                            var li = expandableMenu.createItem($.extend(
                                {
                                    class: classes.menuGroupSearch,
                                    svg: skyward.svg.getSvg("Search").addClass(classes.menuGroupSearchSvg),
                                    data:
                                    {
                                        searchItemThreshold: 10
                                    }
                                }, options));

                            const inputProps = skyward.mobile.supportsInputMode ? { type: "text", inputmode: "numeric" } : { type: "numeric" };
                            li.prepend($("<input>", { class: classes.menuGroupSearchBox, ...inputProps }));

                            li.append($("<div>", { class: classes.menuGroupSearchMessage }));

                            li.append($("<div>", { class: classes.menuGroupSearchClear }));

                            return li;
                        }
                    };

                    return expandableMenu;
                })();

                function getMobileBackButton()
                {
                    var button = $(classes.mobileBackButton.dot());

                    if (window.location.href.match(/\/home\//i) || !window.history.length)
                    {
                        button.addClass(classes.mobileBackButtonDisabled);
                    }

                    return button;
                }

                function getScreenFriendlyName()
                {
                    var friendlyName = $(classes.mobileFriendlyName.dot());
                    if (friendlyName.length)
                    {
                        var friendlyNameText = $("#friendlyNameContents").text();
                        if (friendlyNameText)
                        {
                            friendlyName.text(friendlyNameText.split(" - ")[0]); //TODO: find a better way to remove student name
                        }
                    }
                    return friendlyName;
                }

                function getMobileUserMenu()
                {
                    var headerSelectContainerItems = $(".headerSelectContainer__item > .headerSelect").not(".headerSelect__mode--Section,.js-headerSelect--topLevel");
                    var hasDetails = false;
                    var userMenu = expandableMenu.create(
                        {
                            container:
                            {
                                class: classes.menuGroupUserMenu,
                                on:
                                {
                                    "before-toggle-show": getUserMenuItems,
                                    "after-toggle-hide": collapseMenusInContainer
                                }
                            },
                            title:
                            {
                                svg: function ()
                                {
                                    var graphic = $(".utilitiesButtonMain__svg--userImage");
                                    if (graphic.length)
                                    {
                                        graphic.removeClass("utilitiesButtonMain__svg--userImage");
                                    }
                                    else
                                    {
                                        graphic = $(".utilitiesButtonMain__img");
                                    }
                                    return graphic;
                                },
                                label: function ()
                                {
                                    var elements = $();
                                    var userName = [];

                                    $(".utilitiesButtonMain__text--username").each(function ()
                                    {
                                        userName.push($(this).text());
                                    });

                                    elements = elements.add($("<div>", { class: classes.menuGroupUserName, html: userName.join(" ") }));

                                    headerSelectContainerItems.each(function ()
                                    {
                                        var item = $(this);
                                        if (!item.is("[data-update-action]"))
                                        {
                                            return;
                                        }
                                        var text = item.text().trim();
                                        if (!text.length)
                                        {
                                            return;
                                        }
                                        elements = elements.add($("<div>", { class: classes.menuGroupUserDetail, html: text }));
                                    });

                                    hasDetails = elements.length > 1;

                                    return elements;
                                }
                            }
                        });

                    if (hasDetails)
                    {
                        userMenu.addClass(classes.menuGroupUserMenuHasDetails);
                    }

                    return userMenu;

                    function getUserMenuItems(ul)
                    {
                        var deferred = $.Deferred();

                        if (ul.data("has-items"))
                        {
                            deferred.resolve();
                        }
                        else
                        {
                            var items = $();
                            var myAccountButton = $("#myAccountButton");

                            headerSelectContainerItems.each(function ()
                            {
                                var headerSelect = $(this);
                                if (headerSelect.is(".headerSelect--readonly") || !headerSelect.is("[data-update-action]"))
                                {
                                    return;
                                }
                                var li = expandableMenu.createItem(
                                    {
                                        class: classes.menuGroupItemHasMenu
                                    });

                                var item = getSelectionMenu(this);
                                if (item)
                                {
                                    items = items.add(li.append(item));
                                }
                            });

                            items = items
                                .add(getChangePassword(myAccountButton))
                                .add(getStopImpersonation(myAccountButton))
                                .add(getUserPreferences(myAccountButton))
                                .add(getSupportTools(myAccountButton))
                                .add(getSignOut());

                            ul.append(items).data("has-items", true);

                            /* We need to use a timeout here to allow time for a css paint event to register the added list element.
                             * This is necessary to get the css transition to work properly (it needs to paint the before state before it can know to transition to the after state) */
                            window.setTimeout(deferred.resolve, 50);
                        }

                        collapseMenusInContainer($(classes.menuGroupUserMenu.dot()), ul);

                        return deferred.promise();
                    }

                    function getSignOut()
                    {
                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("SignOut"),
                                label: "Sign Out",
                                on: { click: skyward.header.signOutButtonClick }
                            });
                    }

                    function getSupportTools(myAccountButton)
                    {
                        if (!myAccountButton.length || !((skyward.global.isInHouse && skyward.global.isRealSuperUser) || skyward.global.isRealSupportAccount) )
                        {
                            return $();
                        }

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("Build"),
                                label: "Support Tools",
                                on:
                                {
                                    click: function () { skyward.support.build(); }
                                }
                            });
                    }

                    function getUserPreferences(myAccountButton)
                    {
                        if (!myAccountButton.length)
                        {
                            return $();
                        }

                        var data = myAccountButton.data();

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("User"),
                                label: "User Preferences",
                                on: { click: function () { return skyward.window.loadContent("full", "Security", "UserPreference", "Details", data.userPreferencesPrimaryKeyValue); } }
                            });
                    }

                    function getStopImpersonation(myAccountButton)
                    {
                        if (!myAccountButton.length)
                        {
                            return $();
                        }

                        var data = myAccountButton.data();
                        if (!data.stopUserImpersonation)
                        {
                            return $();
                        }

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("Stop"),
                                label: "Stop User Impersonation",
                                on: { click: function () { return skyward.window.loadContent("full", "Security", "User", "StopImpersonation"); } }
                            });
                    }

                    function getChangePassword(myAccountButton)
                    {
                        if (!myAccountButton.data("changeMyPasswordIconCode"))
                        {
                            return $();
                        }

                        const data = myAccountButton.data();
                        const passwordData =
                        {
                            "Workflow.UserID": data.changeMyPasswordUserId,
                            "Workflow.UserID_securityhash": data.changeMyPasswordUserId_securityhash
                        };

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg(data.changeMyPasswordIconCode),
                                label: "Change Password",
                                on:
                                {
                                    click: function ()
                                    {
                                        return skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Security/User/ChangeMyPassword", null, passwordData)
                                            .then(() =>
                                            {
                                                skyward.mainMenu.closeMenu();
                                            });
                                    }
                                }
                            });
                    }
                }

                function getSelectionMenu(item)
                {
                    item = $(item);
                    var text = item.text().trim();

                    if (!text.length)
                    {
                        return;
                    }

                    return expandableMenu.create(
                        {
                            searchable: true,
                            container:
                            {
                                class: classes.getSelectionMenu,

                                data:
                                {
                                    "update-action": $().add(item.find(".headerSelect")).add(item.filter(".headerSelect")).data("update-action"),
                                    "header-item": item
                                },
                                on:
                                {
                                    "before-toggle-show": getSelectionItems,
                                    "after-toggle-show": scrollMenuIntoView
                                }
                            },
                            title:
                            {
                                label: text,
                                class: classes.menuGroupSelectionTitle
                            }
                        });

                    function getSelectionItems(ul)
                    {
                        var deferred = $.Deferred();

                        if (ul.data("has-items"))
                        {
                            deferred.resolve();
                        }
                        else
                        {
                            var searchBox = ul.data("header-item").find(".tileViewEEL_search");

                            $.ajax(
                                {
                                    url: skyward.global.virtualDir + "Common/TileViewEEL/ViewSearchResults/" + searchBox.val(),
                                    type: "POST",
                                    dataType: "JSON",
                                    activityIndicator: { hideGlass: true },
                                    data: skyward.tileViewEEL.getPostData(searchBox.data(), searchBox),
                                    success: async function (data)
                                    {
                                        var items = $();

                                        var selectedItemKey = ul.data("header-item").find("[data-selected-item-key]").attr("data-selected-item-key");

                                        for (const itemHtml of data.templatedItems)
                                        {
                                            const processedItem = await skyward.global.processViewPartHtml(itemHtml);
                                            const item = $(processedItem);
                                            items = items.add(expandableMenu.createItem(
                                                {
                                                    label: item.text(),
                                                    class: function ()
                                                    {
                                                        var classList = [classes.menuGroupSelectionItem];

                                                        if (!item.find(".headerSelect__option--indented").length)
                                                        {
                                                            classList.push(classes.menuGroupSelectionNoIndent);
                                                        }
                                                        if (item.data("id") == selectedItemKey)
                                                        {
                                                            classList.push("fontBold");
                                                        }
                                                        return classList.join(" ");
                                                    },
                                                    data: { id: item.data("id") },
                                                    on:
                                                    {
                                                        click: function (li)
                                                        {
                                                            var updateAction = ul.data("update-action");

                                                            if (updateAction)
                                                            {
                                                                skyward.mainMenu.closeMenu();
                                                                $.ajax(
                                                                    {
                                                                        url: skyward.global.virtualDir + updateAction,
                                                                        type: "POST",
                                                                        data: { newValue: li.data("id") },
                                                                        success: function (data)
                                                                        {
                                                                            if (data.redirect)
                                                                            {
                                                                                window.location.href = skyward.global.virtualDir + data.redirect;
                                                                            }
                                                                            else
                                                                            {
                                                                                window.location.reload(true);
                                                                            }
                                                                        }
                                                                    });
                                                            }
                                                        }
                                                    }
                                                }));
                                        }

                                        ul.append(items).data("has-items", true);

                                        // We need to use a timeout here to allow time for a css paint event to register the added list element.
                                        //This is necessary to get the css transition to work properly (it needs to paint the before state before it can know to transition to the after state)
                                        window.setTimeout(deferred.resolve, 50);
                                    },
                                    error: function ()
                                    {
                                        deferred.reject();
                                    }
                                });
                        }

                        collapseMenusInContainer($(classes.menuGroupUserMenu.dot()), ul);

                        return deferred.promise();
                    }
                }

                function getMobileTopLevelHeaderSelectMenus()
                {
                    var headerSelect = $(".headerSelectContainer__item > .headerSelect.js-headerSelect--topLevel");
                    return headerSelect.toArray().map(getSelectionMenu).reduce((accum, menu) => accum.add(menu), $());
                }

                function getMobileMenuHomeButton()
                {
                    const homeButton = $("<div>", { class: classes.menuHomeButton });
                    homeButton.append(skyward.svg.getSvg("Home", "Group"));
                    homeButton.append($("<span>", { class: classes.menuHomeButtonText, text: "Home" }));
                    return homeButton;
                }

                function getMobilePortalMenu()
                {
                    if (cache.portalButtons.length <= 1)
                    {
                        return;
                    }

                    var portalButtons = [];
                    var selectedPortal;

                    cache.portalButtons.map(function (data)
                    {
                        var portal =
                        {
                            class: (!data.supported ? classes.menuGroupPortalUnsupported : ""),
                            "data":
                            {
                                "portal-code": data.portalCode,
                                "display-text": data.displayText
                            },
                            "svg": skyward.svg.getSvg(data.icon, "PortalButtons"),
                            "label": data.displayText,
                            "on":
                            {
                                click: function (li)
                                {
                                    if (li.hasClass(classes.menuGroupTitle))
                                    {
                                        return;
                                    }

                                    if (li.hasClass(classes.menuGroupPortalUnsupported))
                                    {
                                        showUnsupportedPortalMessage(li);
                                    }
                                    else
                                    {
                                        selectPortal(li);
                                    }
                                }
                            }
                        };

                        if (cache.selectedPortalCode === data.portalCode)
                        {
                            selectedPortal = portal;
                        }
                        else
                        {
                            portalButtons.push(portal);
                        }
                    });

                    if (!selectedPortal && portalButtons.length)
                    {
                        selectedPortal = portalButtons.shift();
                    }

                    return expandableMenu.create(
                        {
                            container:
                            {
                                class: classes.menuGroupPortalMenu
                            },
                            title: selectedPortal,
                            items: portalButtons
                        });

                    function selectPortal(li)
                    {
                        var portalCode = li.data().portalCode;
                        cache.selectedPortalCode = portalCode;

                        $(classes.menuGroupPortalMenu.dot()).replaceWith(getMobilePortalMenu);

                        $.when(cache.getPortal(portalCode)).then(function (portalData)
                        {
                            var portalContent = constructor.getPortalContentParts();
                            domHandler.appendModuleMenuParts(constructor, portalContent);
                        },
                        function ()
                        {
                            constructor.getMenuLayoutParts().menuModuleList.empty().append($("<div>", { class:"menu-no-results", text: "No Results to Display" }));
                        });
                    }

                    function showUnsupportedPortalMessage(li)
                    {
                        var data = li.data();
                        var content = $("<div>", { class: "modalContent" });
                        var header = $("<div>", { class: "modalContent__header" });

                        var svg = skyward.svg.getSvg("Utilities")
                            .addClass("modalContentHeader__svg")
                            .addClass("svgNoHover");

                        header.append(svg);
                        header.append($("<h1>", { class: "modalContentHeader__text", text: "We're Sorry!" }));

                        content.append(header);

                        content.append($("<p>", { class: "modalContent__text", text: data.displayText + " is currently unavailable within the mobile application." }));
                        content.append($("<p>", { class: "modalContent__text", text: "Until it is available, you can use " + data.displayText + " within a web browser." }));

                        skyward.modalLayer.showInformationDialog("Portal Unavailable", content);
                    }
                }

                function getMobileMessagesButton()
                {
                    const button = $(classes.mobileMessagesButton.dot());

                    const messageCounter = parseInt($("#MessageNotificationContainer").find(".notificationBubble").text());

                    if (messageCounter > 0)
                    {
                        const counterSpan = $("<span>", { class: classes.messageCounter, text: messageCounter });
                        button.append(counterSpan);

                        window.setTimeout(function ()
                        {
                            counterSpan.addClass(classes.messageCounterVisible); /* animate the message counter */
                        }, 200);
                    }

                    return button;
                }

                constructor.getModuleContentParts = function (categoryData)
                {
                    var moduleItems = [];
                    var showHeader = categoryData.length > 1;

                    categoryData.map(function (category)
                    {
                        if (showHeader)
                        {
                            moduleItems.push(expandableMenu.createHeader(
                                {
                                    label: category.label
                                }));
                        }

                        category.menus.map(function (menuItem)
                        {
                            moduleItems.push(expandableMenu.createItem(
                                {
                                    label: menuItem.displayText,
                                    data: menuItem,
                                    on:
                                    {
                                        click: function (li)
                                        {
                                            var data = li.data();
                                            skyward.window.loadContent(data.target, data.module, data.object, data.screen, null, data.data);
                                            $(classes.mobileMenuButton.dot()).trigger("click");
                                        }
                                    }
                                }));
                        });
                    });

                    return moduleItems;
                };

                constructor.getPortalContentParts = function ()
                {
                    var moduleMenus = [];

                    $(cache.selectedModuleButtonDatas).each(function (i, buttonData)
                    {
                        moduleMenus.push(expandableMenu.create(
                            {
                                container:
                                {
                                    class: classes.menuGroupModuleMenu,
                                    data:
                                    {
                                        "module-i-d": buttonData.moduleID
                                    },
                                    on:
                                    {
                                        "before-toggle-show": getModuleMenus,
                                        "after-toggle-show": scrollMenuIntoView
                                    }
                                },
                                title:
                                {
                                    svg: skyward.svg.getSvg(buttonData.icon),
                                    label: buttonData.displayText
                                }
                            }));
                    });
                    return moduleMenus;

                    function getModuleMenus(ul)
                    {
                        cache.selectedModuleID = ul.data().moduleID;

                        var deferred = $.Deferred();

                        collapseMenusInContainer(constructor.layoutParts.menuModuleList, ul);

                        if (!ul.data("hasModules"))
                        {
                            $.when(cache.getModuleCategories(cache.selectedPortalCode, cache.selectedModuleID)).done(function (moduleCategories)
                            {
                                var moduleParts = constructor.getModuleContentParts(moduleCategories);
                                ul.append(moduleParts).data("hasModules", true);
                                /* We need to use a timeout here to allow time for a css paint event to register the added list element.
                                    * This is necessary to get the css transition to work properly (it needs to paint the before state before it can know to transition to the after state) */
                                window.setTimeout(deferred.resolve, 50);
                            });
                        }
                        else
                        {
                            deferred.resolve();
                        }

                        return deferred.promise();
                    }
                };

                constructor.getMenuLayoutParts = function ()
                {
                    if (constructor.layoutParts)
                    {
                        return constructor.layoutParts;
                    }

                    constructor.layoutParts =
                    {
                        header: $(classes.mobileHeader.dot()),
                        menuButton: $(classes.mobileMenuButton.dot()),
                        backButton: getMobileBackButton(),
                        homeButton: $(classes.mobileHomeButton.dot()),
                        messagesButton: getMobileMessagesButton(),
                        friendlyName: getScreenFriendlyName(),
                        menu: $("<div>", { class: classes.mobileMenu }),
                        menuUserMenu: getMobileUserMenu(),
                        menuHeaderSelect: getMobileTopLevelHeaderSelectMenus(),
                        menuPortalMenu: getMobilePortalMenu(),
                        menuModuleList: $("<div>", { class: classes.moduleList }),
                        menuHomeButton: getMobileMenuHomeButton(),
                    };

                    return constructor.layoutParts;
                };

                return constructor;
            };

            var domHandler = (function ()
            {
                var handler = {};
                handler.appendLayoutPartsToDOM = function (layoutParts)
                {
                    layoutParts.header.append(layoutParts.friendlyName);
                    layoutParts.menu.append(layoutParts.menuHeader);
                    layoutParts.menu.append(layoutParts.menuUserMenu);
                    layoutParts.menu.append(layoutParts.menuHeaderSelect);
                    layoutParts.menu.append(layoutParts.menuPortalMenu);
                    layoutParts.menu.append(layoutParts.menuHomeButton);
                    layoutParts.menu.append(layoutParts.menuModuleList);
                    cache.menuLocation.append(layoutParts.menu);
                };
                handler.appendModuleMenuParts = function (constructor, layoutContent)
                {
                    constructor.getMenuLayoutParts().menuModuleList.empty().append(layoutContent);
                };

                return handler;
            })();

            var setEvents = function (constructor)
            {
                var layoutParts = constructor.layoutParts;

                skyward.mainMenu.openMenu = function ()
                {
                    $([classes.menuSource.dot(), classes.mobileGlass.dot()].join(" ")).remove();
                    $(classes.menuSource.dot()).prepend($("<a>", { class: classes.mobileGlass }));
                    layoutParts.menu.addClass(classes.mobileMenuExpanded);
                };

                skyward.mainMenu.closeMenu = function ()
                {
                    layoutParts.menu.removeClass(classes.mobileMenuExpanded);
                    $([classes.menuSource.dot(), classes.mobileGlass.dot()].join(" ")).remove();
                };

                $(document.body).swipe(
                    {
                        preventDefaultEvents: false,
                        swipeStatus: function (event, phase, direction, distance, duration, fingerCount)
                        {
                            if (direction === "up" || direction === "down")
                            {
                                return;
                            }
                            var MENU_COMPLETE_TOLERANCE = 130;
                            var MENU_START_TOLERANCE = 60;
                            var MENU_WIDTH = 300;
                            var startElement;
                            switch (phase)
                            {
                                case "start":
                                    window.cancelTouchSwipe = false;
                                    window.menuIsOpen = skyward.mainMenu.isMenuOpen(); //store as global reference to prevent hitting the dom over and over
                                    if (direction === "left" && !window.menuIsOpen)
                                    {
                                        return;
                                    }
                                    startElement = $(event.target);
                                    if (!window.menuIsOpen && (startElement.closest(".modalLayerContainer").length || hasXScrollingAncestor(event.target)))
                                    {
                                        window.cancelTouchSwipe = true;
                                    }
                                    break;
                                case "move":
                                    if (!window.cancelTouchSwipe)
                                    {
                                        if (window.menuIsOpen)
                                        {
                                            if (direction === "left" && distance > MENU_START_TOLERANCE)
                                            {
                                                layoutParts.menu.css("transform", "translateX(-" + Math.min(distance - MENU_START_TOLERANCE, layoutParts.menu.width()) + "px)");
                                            }
                                        }
                                        else if (direction === "right" && distance > MENU_START_TOLERANCE)
                                        {
                                            layoutParts.menu.css("transform", "translateX(-" + Math.min(MENU_WIDTH, MENU_WIDTH + (MENU_START_TOLERANCE * 2) - distance) + "px)");
                                        }
                                    }
                                    break;
                                case "end":
                                case "cancel":
                                    $(classes.mobileMenu.dot()).css("transform", "");
                                    if (!window.cancelTouchSwipe)
                                    {
                                        if (((window.menuIsOpen && direction === "left") || (!window.menuIsOpen && direction === "right")) && distance > MENU_COMPLETE_TOLERANCE)
                                        {
                                            skyward.mainMenu.toggleMenu();
                                        }
                                    }
                                    break;
                            }

                            function hasXScrollingAncestor(element)
                            {
                                if (!element)
                                {
                                    return false;
                                }
                                var scrollElement = $(element).closest(":scrollable")[0];
                                if (scrollElement)
                                {
                                    if (scrollElement.clientWidth < scrollElement.scrollWidth)
                                    {
                                        return true;
                                    }
                                    else
                                    {
                                        if (scrollElement === element)
                                        {
                                            scrollElement = element.parentNode;
                                        }
                                        return hasXScrollingAncestor(scrollElement);
                                    }
                                }
                                else
                                {
                                    return false;
                                }
                            }
                        }
                    });

                $(document.body).on("click", [classes.menuSource.dot(), classes.mobileGlass.dot()].join(" "), skyward.mainMenu.closeMenu);

                layoutParts.backButton.on("click", function (pEvent)
                {
                    if ($(this).hasClass(classes.mobileBackButtonDisabled))
                    {
                        return;
                    }

                    window.history.back();
                });

                layoutParts.menuButton.on("click", skyward.mainMenu.toggleMenu);

                layoutParts.messagesButton.on("click", function ()
                {
                    skyward.window.loadContent("full", "MessageCenter", "Message", "MyMessages");
                });

                layoutParts.homeButton.on("click", function ()
                {
                    skyward.window.loadContent("full", "home", "home", "index", null, undefined, null, null, null, false, null, null, null);
                });

                layoutParts.menuHomeButton.on("click", function ()
                {
                    let selectedPortal = $(`.${classes.menuGroupPortalMenu} .${classes.menuGroupLabel}`).first().text().replace(/ /g, '');
                    switch (selectedPortal)
                    {
                        case "AdministrativeAccess":
                            selectedPortal = "Administrative";
                            break;
                    }
                    skyward.window.loadContent("full", "home", selectedPortal, "home", null, undefined, null, null, null, false, null, null, null);
                });
            };

            function scrollMenuIntoView(ul)
            {
                /* use a timeout to allow the css transition to complete before checking if it is out of view */
                window.setTimeout(function ()
                {
                    ul.scrollintoview(
                        {
                            viewPadding: { y: -2 }
                        });
                }, 300);
            }

            function collapseMenusInContainer(container, nextMenu)
            {
                var expanded = container.find(classes.menuGroupExpanded.dot());

                if (!expanded.length)
                {
                    return;
                }

                expanded.addClass(classes.menuGroupForcedClosed);

                if (nextMenu && nextMenu.length)
                {
                    nextMenu.scrollintoview(
                        {
                            viewPadding: { y: -2 },
                            duration: 0
                        });
                }

                expanded.removeClass(classes.menuGroupExpanded);

                /* remove the class in a timeout to prevent css transitions from taking effect */
                window.setTimeout(function ()
                {
                    expanded.removeClass(classes.menuGroupForcedClosed);
                }, 200 /* the duration of the css animations */);
            }

            var menu = {};
            menu.initialize = function ()
            {
                $(document.body).addClass("hasMobileMenu");
                var constructor = htmlConstructor();
                var layoutParts = constructor.getMenuLayoutParts();
                domHandler.appendLayoutPartsToDOM(layoutParts);
                domHandler.appendModuleMenuParts(constructor, constructor.getPortalContentParts());
                setEvents(constructor);
            };

            skyward.mainMenu.isMenuOpen = function ()
            {
                return $(classes.mobileMenuExpanded.dot()).length > 0;
            };

            skyward.mainMenu.getBackButton = function ()
            {
                return $(classes.mobileBackButton.dot());
            };

            return menu;
        };

        var init = function ()
        {
            this.find(classes.menuSource.dot()).each(function ()
            {
                var menuSource = $(this);

                if (skyward.global.mobileAccess)
                {
                    cache.initializeOnDomLoad(menuSource, menuSource.data().menu);
                    mobileMenu().initialize();
                }
                else
                {
                    var menuButton = $(classes.jsDesktopMenuVisibilityToggle.dot());
                    skyward.mainMenu = skyward.mainMenuVueBuilder.getMainMenuVue(menuSource[0], menuButton[0]);
                }
            });
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
